import { RECOMMENDATION_CITIES } from '../../../Constants'
import { PartialBrief } from '../../../Types/Brief'

const isRecommendationCity = ({ leadFeedCity }: PartialBrief): boolean =>
  typeof leadFeedCity === 'string' && RECOMMENDATION_CITIES.includes(leadFeedCity)

export default isRecommendationCity
